import { Reducer } from 'react';
import { RouteObject } from 'react-router';

import Client from './client';
import Community from './community';
import Data from './data';
import Deposit from './deposit';
import Documentation from './documentation';
import Files from './files';
import Home from './home';
import Profile from './profile';
import Support from './support';

const modules: Record<string, any> = {
  Client,
  Community,
  Data,
  Deposit,
  Community,
  Data,
  Documentation,
  Files,
  Home,
  Profile,
  Support,
};

const Reducers: Record<string, Reducer<any, any>> = {};
const Actions: Record<string, any> = {};
const Routes: RouteObject[] = [];

Object.keys(modules).forEach((name) => {
  const module = modules[name];

  if (module.Actions) {
    Actions[name] = module.Actions;
  }
  if (module.Reducers) {
    Object.keys(module.Reducers).forEach((n) => {
      Reducers[`${name}${n === name ? '' : n}`] = module.Reducers[n];
    });
  }
  if (module.Routes) {
    Routes.push(...module.Routes);
  }
});

export { Actions, Reducers, Routes };
